<template>
  <div class="integration-status">
    <template v-if="operation">
      <span
        tabindex="0"
        v-tooltip="
          tip(
            `Execution: ${humanize(operation.execution_status)}${
              operation.next_attempt_at ? '. Next attempt: ' + date(operation.next_attempt_at, true) : ''
            }${
              operation.attention_reasons && operation.attention_reasons.length
                ? '. ' + operation.attention_reasons.join('; ')
                : ''
            }`
          )
        "
      >
        <AppStatusBadge design="new" compact :tone="color(operation.execution_status)">
          {{ humanize(operation.execution_status) }}
        </AppStatusBadge>
      </span>
      <span
        v-if="operation.delivery_status && operation.delivery_status !== 'not_applicable'"
        tabindex="0"
        v-tooltip="tip(`Delivery: ${delivery}. This is separate from execution.`)"
      >
        <AppStatusBadge design="new" compact :tone="color(operation.delivery_status)">{{ delivery }}</AppStatusBadge>
      </span>
      <span
        v-if="['pending', 'failed'].includes(operation.sync_status)"
        tabindex="0"
        v-tooltip="tip(`Business updates: ${humanize(operation.sync_status)}`)"
      >
        <AppStatusBadge design="new" compact :tone="color(operation.sync_status)">
          Updates {{ operation.sync_status }}
        </AppStatusBadge>
      </span>
    </template>
    <span
      v-else-if="result"
      tabindex="0"
      v-tooltip="tip(`${humanize(result.domain)}: ${result.label}${result.message ? '. ' + result.message : ''}`)"
    >
      <AppStatusBadge design="new" compact :tone="color(result.status)">{{ result.label }}</AppStatusBadge>
    </span>
  </div>
</template>

<script>
import { humanize, tone, tooltip, dateLabel } from './model'
export default {
  props: { operation: Object, result: Object },
  computed: { delivery() { return this.operation.integration === 'email' && this.operation.delivery_status === 'read' ? 'Opened signal' : humanize(this.operation.delivery_status) } },
  methods: { humanize, color: tone, tip: tooltip, date: dateLabel }
}
</script>
